import React from 'react';
import NavBar from '../NavBar/NavBar';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import firebase from 'firebase/app'
import { setForkBtnTxt, setPopUp, setSaveBtnTxt } from '../../redux/actions/uiActions';



function Login (props) {
    const dispatch = useDispatch()
    const [state, setState] = React.useState({
        credentials: '',
        password: '',
        showReset: false,
        resetEmail : '',
        btnText : "SignIn"
    })
const { show_popup } = useSelector(state => state.uiReducer)

const login = () => {
        setState({
            ...state,
            btnText : "Wait..."
        })
        let { credentials, password } = state;
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() =>{
            return firebase.auth().signInWithEmailAndPassword(credentials,password)
            .then(creds => {
                if(props.isPopUp)
                    {
                        dispatch(setForkBtnTxt("Fork"))
                        dispatch(setSaveBtnTxt("Save"))
                        dispatch(setPopUp(false))
                        alert("Sucess : Now you can save your pen")
                    }
                else
                    window.location.hash = "#/pens";
            })
            .catch((e) => alert(e.message))
            .then(() => {
                setState({
                    ...state,
                    btnText : "Signin"
                })
            })
        })     
}

const handlePasswordReset = () => {
    if(state.resetEmail === '') {
        alert("Please enter email")
        return
    }
    firebase.auth().sendPasswordResetEmail(state.resetEmail)
    .then(res => {
        alert("Please check your inbox to reset your password")
        setState({
            ...state,
            resetEmail : ''
        })
    })
    .catch(e => {
        setState({
            ...state,
            resetEmail : ''
        })
        alert(e)
    })

}

const handleGoogleLogin = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope("https://www.googleapis.com/auth/userinfo.profile")
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() =>{ 
            return firebase.auth().signInWithPopup(provider).then(function (result) {
                const userObj = {
                    name: result.user.displayName,
                    email: result.user.email,
                    username: result.user.email,
                    photo_url : result.user.photoURL ? result.user.photoURL : null,
                    provider : 'google',
                }
                firebase.firestore().collection("users")
                .doc(result.user.uid)
                .set(userObj, { merge : true})
                if(props.isPopUp) 
                    {
                        dispatch(setForkBtnTxt("Save"))
                        dispatch(setSaveBtnTxt("Save"))
                        dispatch(setPopUp(false))
                        alert("Sucess : Now you can save your pen")
                    }
                else
                window.location.hash = "#/pens";
            })
            .catch(e => alert(e.message))
        }) 
} 

return (
<div>
    {!show_popup && <NavBar/>}
    <div className="component-login" style={{backgroundColor : "#1D1E22"}}>
        <div className="login-container" style={{width : show_popup ? '85%' : '60%'}}>
            <div className="login-header">
                <h1 className="text-black mb-10">Login</h1>
            </div>
            <div className="login-types">
                <div className="login-inputs">
                {!state.showReset ? <div>
                        <div className="signup-input-group">
                            <h5>USERNAME OR EMAIL</h5>
                            <input onChange={(e) => setState({
                                ...state,
                                credentials : e.target.value
                            })} 
                            name='credentials' value={state.credentials} type="text" className="signup-input py-1 px-5" />
                        </div>
                        <div className="signup-input-group">
                            <h5>PASSWORD</h5>
                            <input onChange={(e) =>setState({
                                ...state,
                                password : e.target.value
                            })} name='password' value={state.password} type="password" className="signup-input py-1 px-5" />
                        </div>
                        <div className="flex flex-row">
                            <button onClick={login} className="px-10 py-4 bg-green-400 hover:bg-green-500 mr-3 rounded text-white">{state.btnText}</button>
                            <p className="text-large text-blue-400 hover:text-blue-500 align-center cursor-pointer align-middle pt-3" 
                            onClick={() => {
                                setState({
                                    ...state,
                                    showReset : true
                                })
                            }}>Forgot Password?</p>
                        </div>
                    </div> 
                    : 
                    <div className={" my-10"}>
                        <div className="reset-styles">
                            <h3>Reset Your Password</h3>
                            <div className="reset-input-group">
                                <h6>Username Or Email</h6>
                                <input required placeholder='your@email.com' 
                                type="text" value={state.resetEmail} 
                                onChange={e => setState({
                                    ...state,
                                    resetEmail : e.target.value
                                })}
                                className="signup-input py-1 px-5"
                                />
                            </div>
                            <div className="reset-button">
                                <button className="px-10 py-4 mr-3 rounded text-white"  onClick={handlePasswordReset}>Reset</button>
                                <div
                                onClick={() => setState({
                                    ...state,
                                    showReset : false,
                                    resetEmail : ''
                                })}
                                className="text-blue-500 cursor-pointer hover:text-blue-500">Login</div>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="login-divider">
                    <div className="divider-top">
                    </div>
                    <div className="divider-text-container">
                        <div className="divider-text">
                            <h4>OR</h4>
                        </div>
                    </div>
                    <div className="divider-bottom">
                    </div>
                </div>
                <div className="login-socials">
                    <div className="social">
                        <div onClick={handleGoogleLogin} className={`signup-form-twitter cursor-pointer hover:bg-red-300 bg-red-400 py-4 text-white ${show_popup ? 'px-1' : 'px-10'} rounded mt-2`} ><i className="fa fa-google"/> Login using Google</div>
                    </div>
                </div>
            </div>
            <div className="login-signup-container">
                <p className="text-white">Need an account? </p>
                <Link to="/signup" className="px-5 text-blue-400 hover:text-blue-500 "><p>Sign up now!</p></Link>
            </div>
        </div>
    </div>
</div>)
}


export default Login;


// WEBPACK FOOTER //
// ./src/components/Login/Login.js